// src/components/QrCodeCard.jsx
import React, { useEffect, useMemo, useState } from 'react';
import QRCode from 'qrcode';

export default function QrCodeCard({
  url,
  fileBase = 'event-qr',
  previewSize = 256,  // sichtbare Vorschau
  pngSize = 1024,     // Auflösung der PNG-Datei
  ecLevel = 'M',      // L, M, Q, H
  margin = 2,
}) {
  const [pngDataUrl, setPngDataUrl] = useState('');
  const [svgText, setSvgText] = useState('');
  const safeUrl = useMemo(() => String(url || '').trim(), [url]);

  useEffect(() => {
    let cancelled = false;
    async function gen() {
      if (!safeUrl) { setPngDataUrl(''); setSvgText(''); return; }
      try {
        const png = await QRCode.toDataURL(safeUrl, {
          errorCorrectionLevel: ecLevel,
          margin,
          width: pngSize,
        });
        const svg = await QRCode.toString(safeUrl, {
          errorCorrectionLevel: ecLevel,
          margin,
          type: 'svg',
        });
        if (!cancelled) {
          setPngDataUrl(png);
          setSvgText(svg);
        }
      } catch (e) {
        if (!cancelled) {
          setPngDataUrl('');
          setSvgText('');
          // optional: Fehlerbehandlung/Toast
        }
      }
    }
    gen();
    return () => { cancelled = true; };
  }, [safeUrl, pngSize, ecLevel, margin]);

  function downloadPng() {
    if (!pngDataUrl) return;
    const a = document.createElement('a');
    a.href = pngDataUrl;
    a.download = `${fileBase}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  function downloadSvg() {
    if (!svgText) return;
    const blob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
    const urlObj = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = urlObj;
    a.download = `${fileBase}.svg`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(urlObj);
  }
  function copyUrl() {
    if (!safeUrl) return;
    navigator.clipboard?.writeText(safeUrl);
  }

  return (
    <div className="card" style={{ display:'grid', gridTemplateColumns:'auto 1fr', gap:16 }}>
      <div style={{
        width: previewSize, height: previewSize,
        display:'grid', placeItems:'center', background:'#fff',
        borderRadius:8, border:'1px solid #eee'
      }}>
        {pngDataUrl ? (
          <img
            src={pngDataUrl}
            alt="QR"
            style={{ width: previewSize, height: previewSize, objectFit:'contain' }}
          />
        ) : (
          <div style={{ opacity:.6 }}>QR wird erzeugt…</div>
        )}
      </div>

      <div>
        <div style={{ fontSize:12, opacity:.8, wordBreak:'break-all' }}>{safeUrl || '—'}</div>
        <div style={{ display:'flex', gap:8, marginTop:10, flexWrap:'wrap' }}>
          <button className="secondary" onClick={copyUrl} disabled={!safeUrl}>Link kopieren</button>
          <button className="primary" onClick={downloadPng} disabled={!pngDataUrl}>PNG herunterladen</button>
          <button className="secondary" onClick={downloadSvg} disabled={!svgText}>SVG herunterladen</button>
        </div>
        <div style={{ fontSize:12, opacity:.65, marginTop:8 }}>
          Tipp: PNG für Print/Slides (hochauflösend), SVG für Vektordruck/Grafikprogramme.
        </div>
      </div>
    </div>
  );
}